export const createKbUser = `mutation($model : CreateKbUserRequest!){
    createKbUser(input : $model) 
  }`
